import React from 'react'

import { QuotePartProps } from './quote.d';

import QuotationCard from '/react4xp/components/QuotationCard';

function Quote(props: QuotePartProps) {
    return (
        <QuotationCard {...props} />
    )
}

export default (props) => <Quote {...props} /> 
